import { render, staticRenderFns } from "./BsMaEdit.vue?vue&type=template&id=ad3f8b94&scoped=true"
import script from "./BsMaEdit.vue?vue&type=script&lang=js"
export * from "./BsMaEdit.vue?vue&type=script&lang=js"
import style0 from "./BsMaEdit.vue?vue&type=style&index=0&id=ad3f8b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3f8b94",
  null
  
)

export default component.exports